import {
  type DeviceGroupAttribute,
  type GraphPath,
  IPF_NETWORK_VIEWER,
  type Layout,
} from '@ipfabric/utils';
import { setPathLayouts } from 'components/Graph/commands/setPathLayouts';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';
import { loadAttributesSummaryTable } from '../helpers/loadAttributesSummaryTable';

export interface LoadPathLayoutCommand {
  groupBy: DeviceGroupAttribute;
  paths: GraphPath[];
}

export const loadPathLayout: GraphCommandFactory<LoadPathLayoutCommand> =
  (cmdContext, dispatch) => async (command) => {
    let pathResult: { path: GraphPath; label: string; layout: Layout }[] = [];
    const sitePaths = command.paths.filter(
      (path) => path !== IPF_NETWORK_VIEWER,
    );
    if (sitePaths.length) {
      const result = await loadAttributesSummaryTable<{
        label: string;
        path: GraphPath;
        layout: Layout;
      }>(
        cmdContext.api.request,
        {
          pagination: { start: 0, limit: sitePaths.length },
          columns: ['label', 'layout', 'path'],
          filters: {
            name: ['eq', command.groupBy],
            ...(sitePaths.length && {
              or: sitePaths.map((path) => ({ value: ['eq', path] })),
            }),
          },
          snapshotId: cmdContext.getState().snapshotId,
        },
        cmdContext.getState().attributeFilters,
      );
      pathResult = result.data.map((row) => ({
        path: row.path,
        label: row.label,
        layout: row.layout,
      }));
    }
    if (command.paths.includes(IPF_NETWORK_VIEWER)) {
      const allNetwork = await cmdContext.api.request({
        url: `/graphs/default-layout/network-viewer?groupBy=${encodeURIComponent(command.groupBy)}`,
        method: 'GET',
      });
      pathResult.push({
        path: IPF_NETWORK_VIEWER,
        label: IPF_NETWORK_VIEWER,
        layout: allNetwork.layout,
      });
    }

    dispatch(setPathLayouts, {
      groupBy: command.groupBy,
      options: pathResult,
    });
  };
